// FITEASY-specific access policy.
//
// Keep the restricted select_group value and its comparison logic here
// so feature components do not contain duplicated string comparisons.

export const RESTRICTED_SELECT_GROUP = 'fiteasy';

export const isRestrictedSelectGroup = (selectGroup?: string | null): boolean =>
  selectGroup === RESTRICTED_SELECT_GROUP;
